module.exports = __webpack_public_path__ + "static/media/feedback.95432abe.svg";